<template>
  <div>
    <div v-for="(item,index) in menus">
      <el-submenu :index="item.id.toString()" v-if="item.children.length>0">
        <template slot="title"><i :class="item.icon"></i>{{item.rule_name}}</template>
        <MenuTree :menus="item.children"></MenuTree>
      </el-submenu>
      <el-menu-item :index="item.path" v-else>
        <i :class="item.icon"></i>
        <span slot="title">{{item.rule_name}}</span>
      </el-menu-item>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MenuTree",
    props: {
      menus: Array
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/MenuTree.vue